/** CPU and memory usage (ADR 0053, 2026-10-10). Same keys as `usage.fr.ts`. */
export const resourceUsageEn = {
  tab: 'Usage',
  help: 'CPU and memory over the last hour, sampled every 30 s on the cluster and summed over the pods.',
  metrics: {
    cpu: 'CPU (cores)',
    memory: 'Memory (MiB)',
  },
} as const;
